import React, { useEffect, useState, createRef } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/pro-regular-svg-icons/faTimesCircle";

/**
 * @param {object} props
 * @param ref
 * @return {*}
 * @constructor
 */
const InputField = ({ type, onBlur, onFocus, disabled, canReset = false, onChange, className, containerClassName, value, ...rest }, ref) => {
    const [isFocused, setIsFocused] = useState(false);
    const inputRef = createRef(null);

    if (type === undefined) {
        type = 'text';
    }

    useEffect(() => {
        return () => {
            setIsFocused(false);
        };
    }, []);

    useEffect(() => {
        if (!disabled && isFocused && inputRef.current) {
            inputRef.current.focus();
        }
    }, [disabled]);

    return (
        <div className={`relative ${containerClassName}`}>
            <input
                { ...rest }
                disabled={disabled}
                ref={(e) => {
                    if (ref) {
                        ref(e);
                    }
                    inputRef.current = e;
                }}
                type={ type }
                value={ value !== null ? value : '' }
                onChange={ onChange }
                onFocus={(e) => {
                    setIsFocused(true);

                    if (onFocus) {
                        onFocus(e);
                    }
                }}
                onBlur={(e) => {
                    setIsFocused(false);

                    if (onBlur) {
                        onBlur(e);
                    }
                }}
                className={
                    'appearance-none block w-full p-2 border border-gray-300 ' +
                    'rounded-md placeholder-gray-400 focus:outline-none ' +
                    'focus:shadow-outline-blue focus:border-blue-300 transition ' +
                    'duration-150 ease-in-out sm:text-sm sm:leading-5 ' +
                    className
                }
            />

            { !!value && canReset && (
                <div className="absolute right-3 inset-y-0 flex items-center">
                    <FontAwesomeIcon
                        icon={ faTimesCircle }
                        onClick={ () => onChange(null) }
                        className="text-gray-500 transition duration-200 transform hover:scale-125 cursor-pointer"
                    />
                </div>
            ) }
        </div>
    );
};

export default React.forwardRef(InputField);
